// extracted by mini-css-extract-plugin
export var actionText = "_q5-4";
export var container = "_q5-0";
export var leftSection = "_q5-1";
export var rightSection = "_q5-2";
export var settingsButton = "_q5-6";
export var settingsIcon = "_q5-7";
export var shortcut = "_q5-5";
export var shortcutGroup = "_q5-3";